const loadScript = async (src, options = {}) => {
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  const script = document.createElement('script');

  script.src = src;

  // set data attributes
  Object.entries(options).forEach(([key, value]) => {
    script.setAttribute(`data-${key}`, value);
  });

  script.defer = true;

  document.head.appendChild(script);

  await new Promise((resolve, reject) => {
    script.onload = resolve;
    script.onerror = reject;
  });
};

export async function initAISDK() {
  try {
    await loadScript(
      'https://ai.salework.net/ai/sdk/v1/salework-ai.js',
      {
        'app-id': 'AI',
        'api-base': 'https://ai.salework.net/ai',
      }
    );
  } catch (error) {
    console.error('initAISDK -> error:', error);
  }
}